#define PI 3.1415926535897932384626433832795
#include "../utils/noise2D.glsl"

uniform vec2 uResolution;
uniform vec2 uQuadSize;
uniform float uScrollVelocity;
uniform float uTime;

varying vec2 vUv;
varying vec2 vSize;

vec3 deformationCurve(vec3 position, vec2 uv) {
    position.x += -sin(uv.y * PI) * uScrollVelocity * .125; 
    position.y += cos(uv.y * PI) * uScrollVelocity * .05; 
    return position;
}


void main() {
    vUv = uv;
    vSize = mix(uQuadSize, uResolution, 1.0);

    vec3 deformedPosition = deformationCurve(position, vUv);

    gl_Position = projectionMatrix * modelViewMatrix * vec4(deformedPosition, 1.0);
}
